export function getHeaderText(values) {
  let { step, project } = values
  return step == 1 ? "Select Customer" :
    step == 2 ? "Select Project" :
      step == 3 ? "Fill the Details" :
        step == 4 ? `Select ${project.project_name}'s Services` :
          step == 5 ? `Select ${project.project_name}'s Expenses` :
            step == 6 ? `Your Total Cost` :
              ""
}